module.exports = __webpack_public_path__ + "img/bodhitree.c1ac01a3.jpg";